/**
 * Size factor for canvas-drawn messages (stage intros) on short screens.
 *
 * The intros were laid out for a desktop window — a ~440px-tall column of
 * title, animation and prompt — which on a landscape phone (~390–430px
 * tall) runs off both edges. CSS-built messages shrink through media
 * queries; Pixi-built ones scale their content by this instead.
 * Desktop-height screens get exactly 1.
 */
export function messageScale(screenH: number): number {
  if (screenH >= 500) return 1;
  return Math.max(0.5, Math.min(1, screenH / 720));
}
